import React, { useEffect, useState } from "react";
import { Modal, Form, notification, Upload, Row, Col, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import urldata from "../../../../urldata"; // THIS IS THE KEY!
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";

const Edit = ({
  isVisible,
  handleClose,
  moduleName,
  base_url,
  record,
  azure_base,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Use your actual domain, not Azure!
  const imageBaseUrl = azure_base;

  const sizeLimit = config.sizeLimit;
  const allowedExtensions = config.allowed_extensions;
  // ---------------- LOAD EXISTING DATA WITH CORRECT IMAGE URL ----------------
  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        mainImg: record.mainImg
          ? [
              {
                uid: "-1",
                name: "desktop.png",
                status: "done",
                url: azure_base + record.mainImg, // <-- use full path, no replace
              },
            ]
          : [],
        mbMainImg: record.mbMainImg
          ? [
              {
                uid: "-2",
                name: "mobile.png",
                status: "done",
                url: azure_base + record.mbMainImg, // <-- use full path, no replace
              },
            ]
          : [],
        thumb: record.thumb || "",
      });
    }
  }, [record, form, azure_base]);

  // ---------------- SUBMIT ----------------
  const handleSubmit = async (values) => {
    setLoading(true);
    const formData = new FormData();

    const itemsArray = [
      {
        _id: record._id, // existing item id
        thumb: values.thumb || "",
        mainImg: record.mainImg, // keep old path unless replaced
        mbMainImg: record.mbMainImg, // keep old path unless replaced
      },
    ];

    // send items array
    formData.append("items", JSON.stringify(itemsArray));

    // IMPORTANT: backend expects name with index: mainImg_0, mbMainImg_0
    if (values.mainImg?.[0]?.originFileObj) {
      formData.append("mainImg_0", values.mainImg[0].originFileObj);
    }
    if (values.mbMainImg?.[0]?.originFileObj) {
      formData.append("mbMainImg_0", values.mbMainImg[0].originFileObj);
    }

    try {
      await axios.post(
        `${base_url}updateHosLife?id=${record.sectionId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      notification.success({
        message: `${moduleName} Updated Successfully`,
        placement: "topRight",
      });
      handleClose(true);
    } catch (err) {
      notification.error({
        message: err?.response?.data?.message || "Update failed",
      });
    } finally {
      setLoading(false);
    }
  };

  const uploadProps = {
    beforeUpload: () => false,
    maxCount: 1,
    listType: "picture-card",
    accept: ".jpg,.jpeg,.png",
    showUploadList: {
      showPreviewIcon: false,
      showRemoveIcon: true,
    },
  };

  return (
    <Modal
      title={`Edit ${moduleName}`}
      open={isVisible}
      onCancel={() => handleClose(false)}
      okText="Update"
      cancelText="Cancel"
      confirmLoading={loading}
      width={700}
      onOk={() => form.validateFields().then(handleSubmit)}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col xs={24} md={8}>
            <Form.Item
              label="Desktop Image"
              extra="Recommended size: 2310 × 1031"
              name="mainImg"
              valuePropName="fileList"
              getValueFromEvent={(e) =>
                Array.isArray(e) ? e : e?.fileList || []
              }
            >
              <Upload {...uploadProps}>
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              </Upload>
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item
              label="Mobile Image"
              extra="Recommended size: 750 × 1374"
              name="mbMainImg"
              valuePropName="fileList"
              getValueFromEvent={(e) =>
                Array.isArray(e) ? e : e?.fileList || []
              }
            >
              <Upload {...uploadProps}>
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              </Upload>
            </Form.Item>
          </Col>

          <Col xs={24} md={8}>
            <Form.Item label="Image Alt Text" name="thumb">
              <Input placeholder="Enter alt text" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Edit;
